import axios from 'axios';
import config from 'config';

import { isTruthy } from 'lib/Helpers';

export const defaultBannerData = {
  affectedBrands: '',
  alertLevel: null,
  message: null,
  showing: false,
};

export const defaultState = {
  data: defaultBannerData,
};

/**
 * Fetches Alert Banner JSON Data from Current Bucket's `maintenanceBannerData.json` File
 * Env is Set in Each Environment to Specify Where to Look for this File
 * This Will Always Direct to Catch Locally... Fetch is for Active Environments -- Develop, Master, etc.
 * @function fetchBannerData
 * @return {Function} Dispatch of receiveBannerData
 */
export const fetchBannerData = () => {
  return async dispatch => {
    const result = await axios.get(config.maintenanceBannerUrl)
      .then(res => res.request.response)
      .catch(e => {
        console.log('Could not fetch maintenance banner data. Defaulting to default payload');
        return null;
      });
    return isTruthy(result)
      ? dispatch(receiveBannerData(JSON.parse(result)))
      : dispatch(receiveBannerData({
        affectedBrands: '',
        alertLevel: null,
        alertMessage: null,
        shouldShowAlert: false
      }));
  };
};

export const RECEIVE_BANNER_DATA = 'RECEIVE_BANNER_DATA';
/**
 * Sets Retrieved Banner Data in State
 * @function receiveBannerData
 * @param {Object} data
 * @return {Object} RECEIVE_BANNER_DATA Payload
 */
export const receiveBannerData = data => ({
  type: RECEIVE_BANNER_DATA,
  payload: {
    affectedBrands: data.affectedBrands,
    alertLevel: data.alertLevel,
    message: data.alertMessage,
    /* Boolean Value is Written as a string from S3 Bucket File, Convert to Boolean */
    showing: data.shouldShowAlert === 'true',
  },
});

export const HIDE_ALERT_BANNER = 'HIDE_ALERT_BANNER';
/**
 * Resets Banner Date to `defaultBannerData`
 * @function hideAlertBanner
 * @return {Object} HIDE_ALERT_BANNER Payload
 */
export const hideAlertBanner = () => ({
  type: HIDE_ALERT_BANNER,
  payload: { ...defaultBannerData },
});

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case HIDE_ALERT_BANNER:
      return { ...state, data: action.payload };
    case RECEIVE_BANNER_DATA:
      return { ...state, data: action.payload };
    default:
      return state;
  }
}
